var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from "react";
import { TextField as MUITextField } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useNonInitialEffect } from "@versiondos/hooks";
import _ from "lodash";
import InputMask from "react-input-mask";
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return createStyles({
        field: {
            "& .MuiInputBase-root": (_a = {
                    fontWeight: 400
                },
                _a[theme.breakpoints.down("md")] = {
                    borderRadius: "17px",
                    height: "26px",
                    fontSize: "9px",
                    lineHeight: "14px",
                },
                _a[theme.breakpoints.only("lg")] = {
                    borderRadius: "22px",
                    height: "35px",
                    fontSize: "12px",
                    lineHeight: "18px",
                },
                _a[theme.breakpoints.up("xl")] = {
                    borderRadius: "33px",
                    height: "53px",
                    fontSize: "18px",
                    lineHeight: "27px",
                },
                _a["& legend"] = {
                    maxWidth: 0, //Avoid the label border interuption.
                },
                _a["&.Mui-focused .MuiOutlinedInput-notchedOutline"] = {
                    borderWidth: "1px !important",
                    borderColor: "#222222 !important",
                },
                _a["&:not(.Mui-error) input:not([value='']) ~ .MuiOutlinedInput-notchedOutline"] = {
                    borderWidth: "1px !imporant",
                    borderColor: "#222222 !important",
                },
                _a["&.Mui-error .MuiOutlinedInput-notchedOutline"] = {
                    borderColor: "#EA6464 !important",
                },
                _a),
            "& input": (_b = {
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    fontFamily: "Poppins"
                },
                _b[theme.breakpoints.down("md")] = {
                    paddingRight: "17px",
                    paddingLeft: "17px",
                    height: "26px",
                },
                _b[theme.breakpoints.only("lg")] = {
                    paddingRight: "23px",
                    paddingLeft: "23px",
                    height: "35px",
                },
                _b[theme.breakpoints.up("xl")] = {
                    paddingRight: "35px",
                    paddingLeft: "35px",
                    height: "53px",
                },
                _b),
            "& .MuiInputLabel-outlined": (_c = {
                    paddingTop: "0px",
                    paddingBottom: "0px"
                },
                _c[theme.breakpoints.down("md")] = {
                    transform: "translate(17px, 6px)",
                    fontSize: "9px",
                    lineHeight: "14px"
                },
                _c[theme.breakpoints.only("lg")] = {
                    transform: "translate(23px, 9px)",
                    fontSize: "12px",
                    lineHeight: "18px"
                },
                _c[theme.breakpoints.up("xl")] = {
                    transform: "translate(35px, 13px)",
                    fontSize: "18px",
                    lineHeight: "27px"
                },
                _c["&.MuiFormLabel-filled"] = {
                    color: "#222222",
                },
                _c["&.Mui-focused"] = {
                    color: "#222222",
                },
                _c["&.Mui-error"] = {
                    color: "#C14A4A",
                },
                _c["&.Mui-focused.Mui-error"] = {
                    color: "#C14A4A",
                },
                _c["&.MuiInputLabel-shrink"] = (_d = {},
                    _d[theme.breakpoints.down("md")] = {
                        transform: "translate(17px, -10px) scale(0.66)",
                    },
                    _d[theme.breakpoints.only("lg")] = {
                        transform: "translate(23px, -14px) scale(0.66)",
                    },
                    _d[theme.breakpoints.up("xl")] = {
                        transform: "translate(35px, -20px) scale(0.66)",
                    },
                    _d),
                _c),
            width: "100%",
            "& .MuiOutlinedInput-multiline": {
                height: "100%",
                "& .MuiOutlinedInput-inputMultiline": {
                    height: "100% !important",
                }
            },
        }
    });
});
export var DateField = function (props) {
    var _a;
    var classes = useStyles();
    var convertToMDY = function (value) {
        var _a = value.split("-"), year = _a[0], month = _a[1], day = _a[2];
        return month + "/" + day + "/" + year;
    };
    var convertToYMD = function (value) {
        var _a = value.split("/"), month = _a[0], day = _a[1], year = _a[2];
        return year + "-" + month + "-" + day;
    };
    var _b = useState(props.label), label = _b[0], setLabel = _b[1];
    var _c = useState((_a = props.errors) === null || _a === void 0 ? void 0 : _a.some(function (e) { return e.fieldName === props.name; })), error = _c[0], setError = _c[1];
    var _d = useState(props.value ? convertToMDY(props.value) : ""), text = _d[0], setText = _d[1];
    useEffect(function () {
        var hasError = props.errors && props.errors.some(function (e) { return e.fieldName === props.name; });
        setError(hasError);
        if (hasError) {
            setLabel(props.errors.find(function (e) { return e.fieldName === props.name; }).errorMessage);
        }
        else {
            setLabel(props.label);
        }
    }, [props.label, props.errors]);
    useNonInitialEffect(function () {
        var timer = setTimeout(function () {
            props.onChange(convertToYMD(_.replace(text, /_/g, "")), props.name);
        }, 200);
        return function () { return clearTimeout(timer); };
    }, [text]);
    var isNumeric = function (value) {
        return /^\d+$/.test(value);
    };
    var convertToNumbers = function (value) {
        return !value ? "" : value.split("").filter(function (token) { return isNumeric(token); }).join("");
    };
    var validate = function (value) {
        var _a = value.split("/").map(function (v) { return convertToNumbers(v); }), month = _a[0], day = _a[1], year = _a[2];
        var finalMonth = month && parseInt(month) <= 12 ? _.pad(month, 2, '_') : "__";
        var finalDay = day &&
            (([1, 3, 5, 7, 8, 10, 12].includes(parseInt(month)) && parseInt(day) <= 31)
                || ([4, 6, 9, 11].includes(parseInt(month)) && parseInt(day) <= 30)
                || (parseInt(month) === 2 && parseInt(day) <= 29)) ? _.pad(day, 2, '_') : "__";
        var finalYear = year || "____";
        return finalMonth + "/" + finalDay + "/" + finalYear;
    };
    var changeHandler = function (event) {
        var value = event.target.value;
        setText(validate(value));
    };
    return (React.createElement(InputMask, { mask: "99/99/9999", value: text, onChange: changeHandler }, function (inputProps) {
        return React.createElement(MUITextField, __assign({ name: props.name, placeholder: props.placeholder, variant: "outlined", label: label, autoFocus: props.autoFocus, className: clsx(classes.field, props.className), error: error }, inputProps));
    }));
};
export default DateField;
